<template>
  <div class="beneficios-container">
    <div class="beneficios-header">
      <div class="beneficios-title-container">
        <a-button
          type="link"
          class="back-button"
          @click="volverInicio"
        >
          <a-icon type="arrow-left"/>
        </a-button>
        <h1 class="beneficios-title">Beneficios</h1>
      </div>
      <div class="beneficios-controls">
        <a-input-search
          class="beneficios-search"
          placeholder="Buscar beneficios..."
          v-model="searchText"
          @change="handleSearch"
        />
        <!--
        <a-select
          class="beneficios-filter"
          v-model="filterStatus"
          @change="handleFilterChange"
        >
          <a-select-option value="TODOS">Todos</a-select-option>
          <a-select-option value="ACTIVO">Activo</a-select-option>
          <a-select-option value="INACTIVO">Inactivo</a-select-option>
        </a-select>
        -->
      </div>
    </div>

    <!-- Tabs section -->
    <a-tabs v-model="activeTab" class="beneficios-tabs">
      <a-tab-pane key="catalogo" tab="Catálogo">
        <a-spin :spinning="loading">
          <div class="beneficios-grid">
            <a-card
              v-for="beneficio in filteredBeneficios"
              :key="beneficio.id"
              hoverable
              class="beneficio-card"
            >
              <div class="beneficio-header-card">
                <a-avatar
                  :size="48"
                  :style="{ backgroundColor: beneficio.iconColor }"
                  class="beneficio-icon"
                >
                  <img
                    v-if="beneficio.logoUrl"
                    :src="beneficio.logoUrl"
                    :alt="beneficio.nombre"
                    class="beneficio-logo-img"
                  />
                  <span v-else>{{ beneficio.icon }}</span>
                </a-avatar>
                <div class="beneficio-title-section">
                  <h3 class="beneficio-name">{{ beneficio.nombre }}</h3>
                  <a-badge
                    :status="beneficio.estado === 'ACTIVO' ? 'success' : 'default'"
                    :text="beneficio.estado"
                    :class="beneficio.estado === 'ACTIVO' ? 'badge-activo' : 'badge-inactivo'"
                  />
                </div>
              </div>
              <!--              <div class="beneficio-description">
                              <p style="white-space: pre-line;">{{ beneficio.descripcion }}</p>
                            </div>-->
              <div class="beneficio-description">
                <p :class="{'collapsed': !beneficio.expandido}" style="white-space: pre-line;">
                  {{ beneficio.descripcion }}
                </p>
                <a-button
                  type="link"
                  size="small"
                  @click="toggleDescripcion(beneficio)"
                  v-if="beneficio.descripcion && beneficio.descripcion.length > 100"
                >
                  {{ beneficio.expandido ? 'Mostrar menos' : 'Mostrar más' }}
                </a-button>
              </div>
              <div class="beneficio-actions">
                <a-button type="link" @click="verDetalle(beneficio)">
                  Ver detalle
                </a-button>
                <a-button
                  v-if="beneficio.url"
                  type="link"
                  @click="abrirUrl(beneficio.url)"
                >
                  Abrir URL
                </a-button>
              </div>
            </a-card>
          </div>

          <a-empty v-if="filteredBeneficios.length === 0" description="No se encontraron beneficios"/>
        </a-spin>
      </a-tab-pane>

      <a-tab-pane key="administracion" tab="Administración" v-if="tieneRolAdminCatBene">
        <g-master
          ref="masterBeneficios"
          name="beneficios-administracion"
          :endpoint="masterConfig.endpoint"
          :tableSetup="masterConfig.tableSetup"
          :modalFieldsSetup="masterConfig.modalFieldsSetup"
          :useMultipart="true"
          :beforeSend="beforeSendData"
          @action="masterAction"
          @handleOkResp="handleSuccessSave"
          modalWidth="70%"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-dropdown
                  ref="dropdownTipoBeneficio"
                  endpoint="hierarchy_lookup"
                  label="Tipo de Beneficio"
                  :formItemConfig="fiOptions"
                  :decorator="['id_h_type_ben', { rules: [{ required: true, message: 'El tipo es requerido' }] }]"
                  :params="catalogoBeneficiosParams"
                  :cache="true"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" label="Descripción">
                  <a-textarea
                    v-model="descripcionTexto"
                    :rows="4"
                    :maxLength="250"
                    v-decorator="[
                      'description',
                      {
                        rules: [
                          { required: true, message: 'La descripción es requerida' },
                          { max: 250, message: 'La descripción no debe exceder los 250 caracteres' }
                        ],
                        validateTrigger: ['onChange', 'onBlur']
                      }
                    ]"
                    :auto-size="{ minRows: 3, maxRows: 6 }"
                  />
                  <div class="character-counter">
                    {{ descripcionTexto.length }}/250
                  </div>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" label="Estado">
                  <a-select
                    v-decorator="['status', { rules: [{ required: true, message: 'El estado es requerido' }] }]"
                  >
                    <a-select-option value="ACTIVO">ACTIVO</a-select-option>
                    <a-select-option value="INACTIVO">INACTIVO</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" label="URL">
                  <a-input
                    v-decorator="['url', { rules: [{ required: false }] }]"
                    placeholder="https://ejemplo.com"
                  />
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" label="Logo">
                  <a-upload
                    :before-upload="handleBeforeUploadLogo"
                    :file-list="fileListLogo"
                    @remove="handleRemoveLogo"
                    accept="image/*"
                    list-type="picture"
                  >
                    <a-button>
                      <a-icon type="upload"/>
                      Seleccionar imagen
                    </a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
            <a-tag :color="text === 'ACTIVO' ? 'green' : 'red'">
              {{ text }}
            </a-tag>
          </span>
        </g-master>

        <!-- Sección de detalle maestro-detalle -->
        <a-divider orientation="left">Detalles del beneficio</a-divider>
        <a-tabs v-if="beneficioSeleccionadoId" defaultActiveKey="1">
          <a-tab-pane tab="Items del beneficio" key="1">
            <beneficios-items :benefit-id="beneficioSeleccionadoId"></beneficios-items>
          </a-tab-pane>
        </a-tabs>
        <a-alert
          v-else
          message="Seleccione un beneficio"
          description="Seleccione un beneficio de la tabla superior para ver y gestionar sus detalles."
          type="info"
          show-icon
          style="margin-top: 16px;"
        />
      </a-tab-pane>
    </a-tabs>

    <!-- Drawer para ver detalle -->
    <a-drawer
      :visible="drawerDetalleVisible"
      :title="beneficioSeleccionado ? beneficioSeleccionado.nombre : ''"
      placement="right"
      :width="drawerWidth"
      @close="cerrarDrawerDetalle"
      :destroyOnClose="true"
      class="beneficios-drawer"
    >
      <beneficios-detalle
        v-if="beneficioSeleccionado"
        :beneficio-id="beneficioSeleccionado.id"
        :beneficio-info="beneficioSeleccionado"
      />
    </a-drawer>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import BeneficiosDetalle from './BeneficiosDetalle'
  import BeneficiosItems from './BeneficiosItems'

  export default {
    name: 'Beneficios',
    components: {
      BeneficiosDetalle,
      BeneficiosItems
    },
    data () {
      return {
        descripcionTexto: '',
        activeTab: 'catalogo',
        searchText: '',
        filterStatus: 'ACTIVO',
        loading: false,
        drawerDetalleVisible: false,
        beneficioSeleccionado: null,
        beneficios: [],
        httpClient: null,
        fileListLogo: [],
        logoUploads: [],
        catalogoBeneficiosParams: {
          h_lookup_type: 'CATALOGO_BENEFICIOS'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        masterConfig: {
          endpoint: 'benefits_catalog',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID', dataIndex: 'id', sorter: true, width: 80},
              {title: 'Tipo', dataIndex: 'tipo_ben', sorter: true, width: 150},
              {title: 'Descripción', dataIndex: 'description', sorter: true, width: 500},
              {title: 'URL', dataIndex: 'url', sorter: false},
              {
                title: 'Estado',
                dataIndex: 'status',
                sorter: true,
                width: 110,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'id_h_type_ben'},
            {name: 'description'},
            {name: 'url'},
            {name: 'status'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil('benefits_catalog')
      this.cargarBeneficios()
    },
    watch: {},
    computed: {
      filteredBeneficios () {
        let filtered = this.beneficios

        // Filter by status
        if (this.filterStatus !== 'TODOS') {
          const estadoBuscado = this.filterStatus === 'ACTIVO' ? 'ACTIVO' : 'INACTIVO'
          filtered = filtered.filter(beneficio => beneficio.estado === estadoBuscado)
        }

        // Filter by search text
        if (this.searchText) {
          const searchLower = this.searchText.toLowerCase()
          filtered = filtered.filter(beneficio =>
            beneficio.nombre.toLowerCase().includes(searchLower) ||
            beneficio.descripcion.toLowerCase().includes(searchLower)
          )
        }

        // Sort by tipo_ben (nombre)
        filtered = filtered.sort((a, b) => {
          const nombreA = (a.nombre || '').toLowerCase()
          const nombreB = (b.nombre || '').toLowerCase()
          return nombreA.localeCompare(nombreB)
        })

        return filtered
      },
      beneficioSeleccionadoId () {
        return this.masterConfig.tableSetup.selectedRows.length > 0
          ? this.masterConfig.tableSetup.selectedRows[0].id
          : null
      },
      tieneRolAdminCatBene () {
        // Verifica si el usuario tiene el rol de administrador de catálogo de beneficios
        // Busca el rol por nombre en lugar de ID
        if (this.$store.state.userInfo && this.$store.state.userInfo.roles) {
          return this.$store.state.userInfo.roles.some(rol => rol.name === 'AdminCatBene' || rol.nombre === 'AdminCatBene')
        }
        return false
      },
      drawerWidth () {
        if (typeof window === 'undefined') {
          return 600
        }
        const windowWidth = window.innerWidth
        if (windowWidth <= 480) {
          return '100%'
        } else if (windowWidth <= 768) {
          return '90%'
        } else if (windowWidth <= 1024) {
          return '70%'
        }
        return 600
      }
    },
    methods: {
      toggleDescripcion (beneficio) {
        beneficio.expandido = !beneficio.expandido
      },
      cargarBeneficios () {
        this.loading = true
        this.httpClient.get(
          null,
          this.manejaRespuestaCarga,
          this.manejaErrorCarga
        )
      },
      manejaRespuestaCarga (response) {
        this.loading = false

        const beneficiosData = Array.isArray(response.data) ? response.data : response.data.data

        if (beneficiosData && beneficiosData.length > 0) {
          this.beneficios = beneficiosData.map(this.mapearBeneficio)
        } else {
          this.$message.warning('No se encontraron beneficios')
        }
      },
      manejaErrorCarga (error) {
        this.loading = false
        const errorMessage = (error.response && error.response.data && error.response.data.message) || 'Error al cargar beneficios'
        this.$message.error(errorMessage)
      },
      mapearBeneficio (beneficioBackend) {
        const tipoBeneficio = beneficioBackend.tipo_ben || beneficioBackend.type || 'Beneficio'

        // Try to get logo from multiple possible fields
        const logoData = beneficioBackend.logo_base64 ||
          beneficioBackend.logo_path ||
          beneficioBackend.logo_url ||
          null

        return {
          id: beneficioBackend.id,
          nombre: tipoBeneficio,
          icon: this.obtenerIcono(tipoBeneficio),
          iconColor: beneficioBackend.color || this.obtenerColor(tipoBeneficio),
          estado: beneficioBackend.status || 'ACTIVO',
          descripcion: beneficioBackend.description || '',
          url: beneficioBackend.url || null,
          logoUrl: this.procesarLogoUrl(logoData),
          expandido: false
        }
      },
      procesarLogoUrl (logoData) {
        if (!logoData) {
          return null
        }

        // If it's already a URL (starts with http:// or https://)
        if (typeof logoData === 'string' && (logoData.startsWith('http://') || logoData.startsWith('https://'))) {
          return logoData
        }

        // If it's already a data URL (starts with data:)
        if (typeof logoData === 'string' && logoData.startsWith('data:')) {
          return logoData
        }

        // If it's a relative path
        if (typeof logoData === 'string' && logoData.startsWith('/')) {
          return this.$store.state.appSettings.apiurl + logoData
        }

        // If it's base64 string (no prefix), add the data URL prefix
        if (typeof logoData === 'string' && logoData.length > 0) {
          // Detect image format from base64 header or default to png
          const imageFormat = this.detectImageFormat(logoData)
          return `data:image/${imageFormat};base64,${logoData}`
        }

        return null
      },
      detectImageFormat (base64String) {
        if (!base64String || base64String.length < 10) {
          return 'png'
        }

        // Check magic numbers in base64
        const header = base64String.substring(0, 10).toUpperCase()

        if (header.startsWith('IVBORW')) return 'png' // PNG: iVBORw0KGgo
        if (header.startsWith('/9J/')) return 'jpeg' // JPEG: /9j/
        if (header.startsWith('R0LGOD')) return 'gif' // GIF: R0lGODlh
        if (header.startsWith('UKLGR')) return 'webp' // WebP: UklGR

        return 'png' // default
      },
      obtenerIcono (benefitType) {
        const iconos = {
          'alimentacion': '🍔',
          'alimentación': '🍔',
          'educacion': '📚',
          'educación': '📚',
          'belleza': '💄',
          'moda': '👔',
          'recreacion': '🎭',
          'recreación': '🎭',
          'deportes': '⚽',
          'salud': '🏥',
          'transporte': '🚗',
          'vivienda': '🏠',
          'tecnologia': '💻',
          'tecnología': '💻',
          'bienestar': '🌟',
          'cultura': '🎨',
          'ocio': '🎪'
        }
        const tipo = (benefitType || '').toLowerCase().trim()
        return iconos[tipo] || '🎁'
      },
      obtenerColor (benefitType) {
        const colores = {
          'alimentacion': '#52c41a',
          'alimentación': '#52c41a',
          'educacion': '#1890ff',
          'educación': '#1890ff',
          'belleza': '#fa8c16',
          'moda': '#722ed1',
          'recreacion': '#13c2c2',
          'recreación': '#13c2c2',
          'deportes': '#f5222d',
          'salud': '#eb2f96',
          'transporte': '#faad14',
          'vivienda': '#2f54eb',
          'tecnologia': '#722ed1',
          'tecnología': '#722ed1',
          'bienestar': '#52c41a',
          'cultura': '#fa8c16',
          'ocio': '#13c2c2'
        }
        const tipo = (benefitType || '').toLowerCase().trim()
        return colores[tipo] || '#1890ff'
      },
      handleSearch () {
        // Search is handled by computed property
      },
      handleFilterChange () {
        // Filter is handled by computed property
      },
      handleSuccessSave () {
        this.cargarBeneficios()
        this.logoUploads = []
        this.fileListLogo = []
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.logoUploads = []
            this.fileListLogo = []
            break
          case 'masterEdit':
            this.logoUploads = []
            this.fileListLogo = []
            // Asegurar que el dropdown tenga opciones cargadas antes de establecer el valor
            this.$nextTick(() => {
              if (this.$refs.dropdownTipoBeneficio) {
                // Si las opciones están vacías, cargarlas primero
                if (this.$refs.dropdownTipoBeneficio.options.length === 0) {
                  this.$refs.dropdownTipoBeneficio.loadOptions()

                  // Verificar periódicamente si las opciones se cargaron
                  const checkOptions = (attempt = 1) => {
                    setTimeout(() => {
                      if (this.$refs.dropdownTipoBeneficio.options.length > 0) {
                        // Convertir a string para que coincida con el tipo de las opciones
                        const form = this.$refs.masterBeneficios.modal.form
                        form.setFieldsValue({
                          id_h_type_ben: String(action.record.id_h_type_ben)
                        })
                      } else if (attempt < 5) {
                        checkOptions(attempt + 1)
                      }
                    }, 500 * attempt)
                  }

                  checkOptions()
                } else {
                  // Si las opciones ya están cargadas, establecer el valor inmediatamente
                  const form = this.$refs.masterBeneficios.modal.form
                  form.setFieldsValue({
                    id_h_type_ben: String(action.record.id_h_type_ben)
                  })
                }
              }
            })
            break
        }
      },
      verDetalle (beneficio) {
        this.beneficioSeleccionado = beneficio
        this.drawerDetalleVisible = true
      },
      cerrarDrawerDetalle () {
        this.drawerDetalleVisible = false
        this.beneficioSeleccionado = null
      },
      abrirUrl (url) {
        if (url) {
          window.open(url, '_blank')
        } else {
          this.$message.warning('Este beneficio no tiene URL configurada')
        }
      },
      volverInicio () {
        this.$router.push('/')
      },
      handleBeforeUploadLogo (file) {
        const isImage = file.type.startsWith('image/')
        if (!isImage) {
          this.$message.error('Solo se pueden subir archivos de imagen')
          return false
        }
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('La imagen debe ser menor a 5MB')
          return false
        }

        this.logoUploads = [file]
        this.fileListLogo = [file]

        return false
      },
      handleRemoveLogo () {
        this.logoUploads = []
        this.fileListLogo = []
      },
      beforeSendData (formData) {
        if (this.logoUploads.length > 0) {
          formData.logo = this.logoUploads[0]
        }
        return formData
      }
    }
  }
</script>

<style scoped>
  .beneficio-description p.collapsed {
    display: -webkit-box;
    -webkit-line-clamp: 4; /* máximo 4 líneas */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .beneficio-description {
    flex-grow: 1;
    margin: 12px 0;
    color: #666;
    font-size: 14px;
    word-break: break-word;
  }

  /* el texto sigue alineado a la izquierda */
  .beneficio-description p {
    margin: 0;
    color: #6b7280;
    font-size: 14px;
    white-space: pre-line;
    text-align: left;
  }

  /* el botón se alinea a la derecha */
  .beneficio-description .ant-btn-link {
    display: block;        /* ocupa toda la línea */
    text-align: right;     /* contenido a la derecha */
    margin-top: 4px;
    font-size: 13px;
    color: #2563eb;
    padding: 0;
  }

  .beneficios-container {
    padding: 20px;
  }

  .beneficios-header {
    background: linear-gradient(135deg, #003a8c 0%, #0050b3 100%);
    padding: 24px 32px;
    border-radius: 8px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
  }

  .beneficios-title-container {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .back-button {
    color: white !important;
    font-size: 20px;
    padding: 4px 8px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .back-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  .back-button i {
    font-size: 20px;
  }

  .beneficios-title {
    color: white;
    font-size: 28px;
    font-weight: 600;
    margin: 0;
  }

  .beneficios-controls {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
  }

  .beneficios-search {
    width: 280px;
    min-width: 200px;
  }

  .beneficios-filter {
    width: 140px;
    min-width: 100px;
  }

  .beneficios-tabs {
    background: white;
    padding: 16px;
    border-radius: 8px;
  }

  .beneficios-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 16px;
  }

  .beneficio-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    transition: all 0.3s ease;
    border: 1px solid #e5e7eb;
  }

  .beneficio-card:hover {
    box-shadow: 0 12px 24px rgba(2, 6, 23, 0.08);
    transform: translateY(-1px);
  }

  .beneficio-header-card {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  .beneficio-icon {
    flex-shrink: 0;
    font-size: 20px;
    font-weight: bold;
    color: white;
  }

  .beneficio-logo-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .beneficio-title-section {
    flex: 1;
    min-width: 0;
  }

  .beneficio-name {
    margin: 0 0 6px 0;
    font-size: 16px;
    font-weight: 700;
    color: #262626;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .badge-activo {
    color: #52c41a;
  }

  .badge-inactivo {
    color: #d9d9d9;
  }

  .character-counter {
    text-align: right;
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 4px;
  }

  .beneficio-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
    flex-wrap: wrap;
  }

  .beneficio-actions .ant-btn-link {
    padding: 0;
    height: auto;
    font-weight: 700;
    color: #2563eb;
    font-size: 14px;
  }

  @media (max-width: 768px) {
    .beneficios-container {
      padding: 12px;
    }

    .beneficios-header {
      padding: 16px;
      flex-direction: column;
      align-items: flex-start;
    }

    .beneficios-title {
      font-size: 22px;
    }

    .beneficios-controls {
      width: 100%;
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }

    .beneficios-search,
    .beneficios-filter {
      width: 100%;
    }

    .beneficios-tabs {
      padding: 8px;
    }

    .beneficios-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .beneficio-card {
      margin-bottom: 0;
    }

    .beneficio-name {
      font-size: 15px;
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
    }

    .beneficio-description {
      min-height: auto;
    }

    .beneficio-description p {
      font-size: 13px;
      -webkit-line-clamp: 2;
      line-clamp: 2;
    }

    .beneficio-actions {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }

    .beneficio-actions .ant-btn-link {
      font-size: 13px;
    }
  }

  @media (max-width: 480px) {
    .beneficios-container {
      padding: 8px;
    }

    .beneficios-header {
      padding: 12px;
      margin-bottom: 12px;
    }

    .beneficios-title {
      font-size: 20px;
    }

    .beneficio-icon {
      font-size: 18px;
    }

    .beneficio-header-card {
      gap: 8px;
    }

    .beneficio-name {
      font-size: 14px;
    }

    .beneficio-description {
      max-height: 200px;
      overflow-y: auto;
    }
  }

  /* Estilos para el drawer responsive */
  .beneficios-drawer >>> .ant-drawer-header {
    padding: 16px;
  }

  .beneficios-drawer >>> .ant-drawer-title {
    font-size: 18px;
    line-height: 1.4;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .beneficios-drawer >>> .ant-drawer-body {
    padding: 16px;
  }

  @media (max-width: 768px) {
    .beneficios-drawer >>> .ant-drawer-header {
      padding: 12px;
    }

    .beneficios-drawer >>> .ant-drawer-title {
      font-size: 16px;
      padding-right: 24px;
    }

    .beneficios-drawer >>> .ant-drawer-body {
      padding: 12px;
    }
  }

  @media (max-width: 480px) {
    .beneficios-drawer >>> .ant-drawer-header {
      padding: 10px;
    }

    .beneficios-drawer >>> .ant-drawer-title {
      font-size: 15px;
      padding-right: 20px;
    }

    .beneficios-drawer >>> .ant-drawer-body {
      padding: 10px;
    }

    .beneficios-drawer >>> .ant-drawer-close {
      padding: 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/Beneficios.vue